import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";

export default function Services() {
  const { t, localize, fmtSAR } = useI18n();
  const [services, setServices] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const filtered = active === "all" ? services : services.filter((s) => s.category_id === active);

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{t("nav.services")}</h1>
      <p className="mt-2 text-slate-500">{t("home.services_sub")}</p>
      <div className="mt-6 flex flex-wrap gap-2">
        <button onClick={() => setActive("all")} data-testid="cat-all" className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${active === "all" ? "bg-primary text-white" : "border border-border bg-white text-slate-600"}`}>{t("common.all")}</button>
        {cats.map((c) => (
          <button key={c.id} onClick={() => setActive(c.id)} data-testid={`cat-${c.id}`} className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${active === c.id ? "bg-primary text-white" : "border border-border bg-white text-slate-600"}`}>{localize(c, "name")}</button>
        ))}
      </div>
      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((s) => (
          <Link key={s.id} to={`/services/${s.id}`} data-testid={`service-card-${s.id}`} className="group overflow-hidden rounded-2xl border border-border bg-white transition-all hover:-translate-y-1 hover:shadow-xl">
            <div className="aspect-[16/10] overflow-hidden"><img src={s.image} alt="" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" /></div>
            <div className="p-5">
              <h3 className="text-lg font-bold text-slate-900">{localize(s, "name")}</h3>
              <p className="mt-1 line-clamp-2 text-sm text-slate-500">{localize(s, "desc")}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-sm text-slate-400">{s.duration_minutes} {t("common.minutes")}</span>
                <span className="font-bold text-primary">{t("common.from")} {fmtSAR(s.price)}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
